export default __webpack_public_path__ + "static/media/Spiderman.7314682d.png";